import { createRoute } from "@tanstack/react-router";
import { UnsubscribePage } from "pages/app/UnsubscribePage";
import { validate as isValidUUID } from "uuid";

import { rootRoute } from "../rootRoute";

// Public route (no auth): unsubscribe links are opened by logged-out email recipients.
// `token` is the LeadSubscription id, read from the `?token=` search param.
export const unsubscribeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/unsubscribe",
  staticData: { pageName: "Unsubscribe" },
  validateSearch: (search: Record<string, unknown>): { token: string | null } => ({
    token: typeof search.token === "string" && isValidUUID(search.token) ? search.token : null,
  }),
  component: function UnsubscribeRouteComponent() {
    const { token } = unsubscribeRoute.useSearch();
    return <UnsubscribePage token={token} />;
  },
});
